// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const DomainsHostsIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 34 30">
    <path
      fill="url(#domains-hosts_svga)"
      d="M17 6.67V0H.33v30h33.34V6.67zm-10 20H3.67v-3.34H7zM7 20H3.67v-3.33H7zm0-6.67H3.67V10H7zm0-6.66H3.67V3.33H7zm6.67 20h-3.34v-3.34h3.34zm0-6.67h-3.34v-3.33h3.34zm0-6.67h-3.34V10h3.34zm0-6.66h-3.34V3.33h3.34zm16.66 20H17v-3.34h3.33V20H17v-3.33h3.33v-3.34H17V10h13.33zM27 13.33h-3.33v3.34H27zM27 20h-3.33v3.33H27z"
    />
    <defs>
      <linearGradient
        id="domains-hosts_svga"
        x1={0.33}
        x2={31.07}
        y1={0}
        y2={32.46}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6E45E2" />
        <stop offset={1} stopColor="#A22E95" />
      </linearGradient>
    </defs>
  </svg>,
  "DomainsHosts",
);
export default DomainsHostsIcon;
